import React, { FC } from "react";
import { ConnectedProps, connect } from "react-redux";
import { Text, Image, Link } from "@fluentui/react-components";

import { IRapComponentProperties } from "../../platform/Layout";
import { IUhfViewState } from "../../pages/Contracts";
import uhfHeaderImage from "../../styling/images/UHF Header Sample with Text.png";
import uhfFooterImage from "../../styling/images/UHF Footer Sample.png";
import onboardingImage from "../../styling/images/UHF_Illustrations_GettingStarted_VP5.png";
import faqImage from "../../styling/images/UHF_Illustrations_Migrating_VP5.png";
import supportImage from "../../styling/images/UHF_Illustrations_Support_VP5.png";
import testImage from "../../styling/images/UHF_Illustrations_TestYourSite_VP5.png";
import { localizedStrings } from "../../common/localization/LocalizedStrings";

import * as LocaleUtils from "../../platform/core/util/Locale";

import "./HomeView.scss";
import { Banner } from "../../common/components/Banner/Banner";

interface IHomeViewProvidedProps extends IRapComponentProperties {

}

interface IHomeViewOwnProps {

}

export type IHomeViewProps = ConnectedProps<typeof connector> & IHomeViewProvidedProps;

const HomeViewInitializer: FC<IHomeViewProps> = (props) => {
    return (
        <div className="c-home-information t-uhf-text-font-size">
            <Banner/>
            <div className="flex-row">
                <div>
                    <Text as="h2" className="c-title" size={900}>
                        {localizedStrings.HomeView?.title}
                    </Text>
                </div>
            </div>
            <Image className="c-header-image" alt={localizedStrings.HomeView?.headerAltText} src={uhfHeaderImage}/>
            <Image className="c-footer-image" alt={localizedStrings.HomeView?.footerAltText} src={uhfFooterImage}/>

            <div className="c-uhf-intro">
                <Text size={400}>{localizedStrings.HomeView?.uhfexplanation}</Text>
                <Text block size={600} as={"h3"} className="c-column-header c-uhf-subtitle t-uhf-large-header-font-size">{localizedStrings.HomeView?.howUhfWorks}</Text>
                <Text block size={400}>{localizedStrings.HomeView?.howUhfWorksTextOne}</Text>
                <br />
                <Text block size={400}>{localizedStrings.HomeView?.howUhfWorksTextTwo}</Text>
            </div>

            <div className="c-link-boxes">
                <div className="c-column">
                    <Image className="c-link-box-image" alt={localizedStrings.HomeView?.linkBoxOneImageAltText} src={onboardingImage}/>
                    <Text as={"h3"} size={500} className="c-column-header">{localizedStrings.HomeView?.linkBoxOne}</Text>
                    <Text size={400}>{localizedStrings.HomeView?.linkBoxOneText}</Text>
                    <Link aria-label="Start onboarding" className="c-link" href="https://eng.ms/docs/cloud-ai-platform/commerce-ecosystems/customer-experience/mse-stores/universal-header-and-footer/uhf-universal-header-footer/partner-faq/uhf-onboarding">{localizedStrings.HomeView?.linkBoxOneLinkText}</Link>
                </div>

                <div className="c-column">
                    <Image className="c-link-box-image" alt={localizedStrings.HomeView?.linkBoxTwoImageAltText} src={faqImage}/>
                    <Text as={"h3"} size={500} className="t-uhf-text-font-size c-column-header">{localizedStrings.HomeView?.linkBoxTwo}</Text>
                    <Text size={400}>{localizedStrings.HomeView?.linkBoxTwoText}</Text>
                    <Link aria-label="Frequently asked questions" className="c-link" href="https://eng.ms/docs/cloud-ai-platform/commerce-ecosystems/customer-experience/mse-stores/universal-header-and-footer/uhf-universal-header-footer/partner-faq">{localizedStrings.HomeView?.linkBoxTwoLinkText}</Link>
                </div>

                <div className="c-column">
                    <Image className="c-link-box-image" alt={localizedStrings.HomeView?.linkBoxThreeImageAltText} src={supportImage}/>
                    <Text as="h3" size={500} className="c-column-header">{localizedStrings.HomeView?.linkBoxThree}</Text>
                    <Text size={400}>{localizedStrings.HomeView?.linkBoxThreeText}</Text>
                    <Link aria-label="Email support" className="c-link" href="mailto:uhfsupport@microsoft.com">{localizedStrings.HomeView?.linkBoxThreeLinkText}</Link>
                </div>

                <div className="c-column">
                    <Image className="c-link-box-image" alt={localizedStrings.HomeView?.linkBoxFourImageAltText} src={testImage}/>
                    <Text as={'h3'} size={500} className="t-uhf-text-font-size c-column-header">{localizedStrings.HomeView?.linkBoxFour}</Text>
                    <Text size={400} className="t-uhf-small-text-font-size">{localizedStrings.HomeView?.linkBoxFourText}</Text>
                    <Link aria-label="Test page" className="c-link" href={`/${LocaleUtils.getLocale()}/test`}>{localizedStrings.HomeView?.linkBoxFourLinkText}</Link>
                </div>

            </div>
        </div>
    );
}

function mapStateToProps(state: IUhfViewState, providedProps: IHomeViewProvidedProps): Partial<IHomeViewOwnProps> {
    return {
        ...providedProps,
    };
}

const ActionsToDispatch = {

};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const HomeView = connector(HomeViewInitializer);
